import { type FC } from "react";

import { faPencil } from "@fortawesome/pro-duotone-svg-icons/faPencil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ButtonLink, type ButtonLinkProps } from "@styled/button_link";

export type EditLinkProps = ButtonLinkProps & {
  to: string;
};

export const EditLink: FC<EditLinkProps> = ({
  children = "Edit",
  size = "sm",
  ...props
}) => (
  <ButtonLink size={size} {...props}>
    <FontAwesomeIcon icon={faPencil} /> {children}
  </ButtonLink>
);
